/*
 * @Author: 刘枫
 * @Date: 2020-10-27 10:46:47
 * @Last Modified by: 李志远
 * @Last Modified time: 2021-11-Th 01:57:04
 */

import { get, post, post2, postSettle } from "utils/post";
/*
 登录
 */
export function login(data) {
  return post2("/api/phone/login", data);
}

/*
 结算登录
 */
export function loginNew(data) {
  return postSettle("/api/client/common/login", data);
}

// 获取登录用户信息   结算重构
export function getUserInfoNew(data) {
  return postSettle("/api/client/user/getUserInfo", data);
}
/*
获取支付类型
*/
export function getPaymentStatus(data) {
  return post2("/api/pay/paymentStatus/get", data);
}
/*
/*
 注销
 */
// export function loginOut(data) {
//   return post('/api/phone/loginOut', data)
// }
// 结算重构接口
export function loginOut(data) {
  return post2("/api/client/common/logout", data);
}
/*
 每日签到
 */
export function memberSign(data) {
  return post2("/api/member/addSignInfo", data);
}
/*
 获取签到信息
 */
export function getSigned(data) {
  return post2("/api/member/getSignInfo", data);
}

/*
 修改密码   结算重构
 */
export function updatePwd(data) {
  /*
   商城接口
  */
  //return post('/api/member/updatePwd',data)
  /*
   结算接口
  */
  return postSettle("/api/client/user/updatePwdByCode", data);
}

/*
 重置密码   陈斌
 */
export function resetPwd(data) {
  return postSettle("/api/client/user/resetPwd", data);
}

/*
 校验用户名是否存在   陈斌
 */
export function isExistLoginName(data) {
  return postSettle("/api/client/user/isExistLoginName", data);
}

/*
 修改个人信息
 */

export function updateProfile(data, type) {
  return postSettle("/api/member/improveMemberInfo", data, type);
}

/*
 获取省市县接口
 */
export function getAddressInfo(data) {
  return post2("/api/phone/region/list", data);
}

/*
 获取乡镇接口
 */
export function getAddressTowns(data) {
  return post2("/api/phone/region/detail/list", data);
}

/*
 获取获取开户行列表
 */
 export function getBankList(data) {
  return post2("/api/banks/getBankList", data);
}

/*
 获取获取开户行支行列表
 */
 export function getBankBranchList(data) {
  return post2("/api/banks/getBankBranchList", data);
}

/*
 收货地址列表
 */
export function addressList(data) {
  return post("/api/member/address/list", data);
}

/*
 新增收货地址
 */
export function addressAdd(data) {
  return post2("/api/member/address/save", data);
}

/*
 修改收货地址
 */
export function addressUpdate(data) {
  return post2("/api/member/address/update", data);
}

/*
 删除收货地址
 */
export function addressDelete(data) {
  return post2("/api/member/address/delete", data);
}

/*
 获取收藏商品列表
 */
export function getFavoriteList(data) {
  return post2("/api/collection/list", data);
}

/*
 获取收藏店铺列表
 */
export function getCollectStoreList(data) {
  return post2(`/api/collection/list`, data);
}

/*
 取消店铺收藏
 */
export function collectStoreDelete(data) {
  return post2("/api/collection/delete", data);
}

/*
 获取我的评论列表
 */
export function getMyCommentList(pageNo, pageSize) {
  return post2(`/api/personal/myComment?pageNo=${pageNo}&pageSize=${pageSize}`);
}

/*
 读取用户信息或者会员信息
 */
export function getUserInfo(data) {
  return post2("/api/member/getMemberInfo", data);
}

/*
 读取会员首页统计信息
 */
export function getUserStat(data) {
  return post2("/api/personal/statistics", data);
}
/*
 读取会员首页推荐商品信息
 */
export function getUserRecommend(data) {
  return post("/api/personal/recommend", data);
}

/*
 获取购物积分获取记录列表
 */
export function getRecordList(data) {
  return post("/api/member/moneyRecord", data);
}

/*
 查看我的成长值列表
 */
export function getMyGrowthList(data) {
  return post("/api/member/myGrowth", data);
}

/*
 获取购物积分和 获取用户账户信息和 获取消费期权、创投期权、网点期权、高管期权数据 方法合并方便以后维护
 */
// export function getMyPoint(data) {
//   return post('/api/user/showAccount', data)
// }
export function getMyPoint(data) {
  // 结算接口重构
  return postSettle("/api/client/wallet/getUserDeposit", data);
}

// 获取会员等级
// /api/client/user/getMemberLevel
export function getMemberLevel(data) {
  // 结算接口重构
  return postSettle("/api/client/user/getMemberLevel", data);
}

export function getNoLoginUserInfo(data) {
  // 结算接口重构
  return postSettle("/api/client/user/getNoLoginUserInfo", data);
}

/*
 获取查询会员即将过期积分
 */
// export function getOverdue(data) {
//   return post('/api/user/getBeingExpiredDeposit', data)
// }

export function getOverdue(data) {
  return post2("/api/client/wallet/getWillExpiredDeposit", data); // 结算重构
}

/*
 获取退换货列表
 */
export function getReturnsOrderList(data) {
  return post2("/api/returnOrder/list", data);
}

/*
 退换货申请
 */
export function returnApply(data) {
  return post2("/api/returnOrder/apply", data);
}

/*
 在线充值 高春超
 在线充值和查看余额公用一个接口
 */
export function onlinePay(data) {
  return post("/api/shop/account", data);
}
/*
我的积分 高春超 2018年3月9日22:06:03
 */
export function pointList(data) {
  return get("/api/personal/pointList", data);
}
/*
我的冻结积分 高春超 2018年3月9日22:06:03
 */
export function pointFreezeList(data) {
  return get("/api/personal/pointFreezeList", data);
}
/*
 获取我的咨询列表
 */
export function getaskList(data) {
  return post("/api/personal/myAsk", data);
}
/*
 获取我的抽奖次数
 */
export function getDrawTimes(data) {
  return post("/api/personal/luckydipTimesByType", data);
}
/*
 抽奖
 */
export function getDrawDetails(data) {
  return post("/api/personal/doLuckydip", data);
}

/**
 取消退换货接口
* */
export function cancelReturnApply(data) {
  return post2("/api/returnOrder/cancelApply", data);
}

/**
 获取用户账户信息
* */
// export function getUserAccountMsg(data) {
//   return post('/api/member/shopping', data)
// }

// /**
//  奖金积分转商城购物积分
// * */
// export function transferAccount(data) {
//   /**
//     商城
//   * */
//   //return post('/api/personal/userTransfer',data)
//   /**
//     结算
//   * */
//   return post('/api/user/transfer', data)
// }

/**
 奖金积分转商城购物积分  结算重构
* */
export function transferAccount(data) {
  /**
    商城
  * */
  //return post('/api/personal/userTransfer',data)
  /**
    结算
  * */
  return postSettle("/api/client/wallet/convertPoint", data);
}

/**
 充值积分
* */
export function investAccount(data) {
  return post2("/api/pay/rechargePay", data);
}
/**
 微信充值积分
* */
// export function weixinSign(totalFee) {
//   return get('/api/recharge/weixinSign?totalFee=' + totalFee + '&tradeType=NATIVE')
// }
// /**
//  消费期权
// * */
// export function consumeConfirm(data) {
//   /**
//     商城
//   * */
//   //return post('/api/personal/consumeConfirm',data)
//   /**
//     结算
//   * */
//   return post('/api/user/consumeConfirm', data)
// }

/**
 消费期权  结算重构
* */
export function consumeConfirm(data) {
  /**
    商城
  * */
  //return post('/api/personal/consumeConfirm',data)
  /**
    结算
  * */
  return postSettle("/api/client/user/verifyPayPassword", data);
}

/**
 支付宝提现
* */
export function userWithdrawAlipay(data, type) {
  /*商城*/
  // return post('/apiUser/userWithdrawAlipay', data)
  return postSettle("/api/client/wallet/applyWithdraw", data, type); // 结算重构
}

/**
 银行卡提现银行信息
* */
export function getWithdrawUserInfo(type, data) {
  // return post('/api/personal/withdrawUserInfo/get?type=' + type)
  if (type == 1) {
    // return post('/apiUser/showShopownerReflectUserInfo', data)
    return post2("/api/client/wallet/getExtractionCashInfo", data); // 结算重构
  } else {
    return post("/api/personal/withdrawUserInfo/get?type=" + type);
  }
}

/**
 银行卡提现申请
* */
export function withdrawPoints(data) {
  /**
    商城
  * */
  // return post2('/api/personal/userWithdrawBanks', data)
  return postSettle("/api/client/wallet/applyWithdraw", data); // 结算接口重构
}

// 网店积分提现
export function shopDrawPoints(data) {
  /**
    商城
  * */
  return post2("/api/personal/userWithdrawBanks", data);
}
/**
 * 获取扣税后的提现金额
 */
// export function getCalGoldWithdraw(data) {
//   /* 商城 */
//   //return post('/api/personal/getCalGoldWithdraw', data)
//   /* 结算 */
//   return post('/apiUser/calGoldWithdraw', data)
// }
// 获取扣税后的提现金额   结算重构
export function getCalGoldWithdraw(data) {
  /* 商城 */
  //return post('/api/personal/getCalGoldWithdraw', data)
  /* 结算 */
  return post2("/api/client/wallet/getUserBonusAfterTaxMoney", data);
}

/**
 获取消费期权、创投期权、网点期权、高管期权数据
* */
// export function getManageShare(data) {
//   return post('/api/member/shopping', data)
// }

/**
 * 分页查询积分明细列表
 * type 类型：String  必有字段  备注：积分类型：通用积分3,奖金积分1,商家余额4，冻奖金积分13,换购积分16
 * @param data
 */
export function getPointItem(query) {
  return post2("/api/client/wallet/listCodePayDetail", query);
}
/**
 * 分页查询积分明细列表
 * type 类型：String  必有字段  备注：积分类型：通用积分3,奖金积分1,商家余额4，冻奖金积分13,换购积分16
 * @param data
 */
export function getPointItemNew(query) {
  return post2("/api/client/wallet/listMustIntegralFlow", query);
}
/**
 * 获取支付验证码
 */
export function getPayCode(data) {
  return post2("/api/member/getVerificationCode", data);
}
/**
 * 查询是否申请过联盟商家
 */
export function isApplyLeague(data) {
  return post2("/api/member-league/isApply", data);
}
/**
 * 查询联盟商家信息
 */
export function findMemberLeague(data) {
  return post2("/api/member-league/findLeagueInfo", data);
}
/**
 * 修改联盟商家信息
 */
export function modifyMemberLeague(data) {
  return post2("/api/member-league/modifyMemberLeague", data);
}
/**
 * 申请联盟商家
 */
export function applyLeague(data) {
  return post2("/api/member-league/applyLeague", data);
}

/**
 * 获取下级地址
 */
export function getListJsonByPrimaryKey(data) {
  return post2("/v1/api/region/listJsonByPrimaryKey", data);
}

/**
 * 重新申请联盟商家信息
 */
export function reApplyLeague(data) {
  return post2("/api/member-league/reApplyLeague", data);
}

/**
 * 获取军团名字
 */
export function getUserLegionInfo(data) {
  return post2("/v1/api/basket/legions/getUserLegionInfo", data);
}

/**
 * 更新经纬度
 */
export function updateXYInfoById(data) {
  return post2("/api/league/updateXYInfoById", data);
}

/**
 * 获取经营类目
 */
export function getStoreCat(data) {
  return post2("/api/league/queryStoreCat", data);
}

/**
 * PC店铺相关搜索
 */
export function getStoreSearch(data) {
  return post2("/api/store/search", data);
}

/**
 * 获取军团信息
 */
export function getArmyGroupDatas(data) {
  return post2("/api/member-league/findLegionList", data);
}

export function updateLegionSn(data) {
  return post2("/api/client/user/updateLegionSn", data);
}

/*
 发送绑卡信息  陈斌
 */
 export function sendBindCard(data) {
  return postSettle("/api/client/bindCard/sendBindCard", data);
}

/*
 绑卡验证  陈斌
 */
 export function bindCardVerify(data) {
  return postSettle("/api/client/bindCard/bindCardVerify", data);
}

/*
 卡列表  陈斌
 */
 export function getCardList(data) {
  return postSettle("/api/client/bindCard/list", data);
}

/*
 设置默认卡  陈斌
 */
 export function defaultCard(data) {
  return postSettle("/api/client/bindCard/defaultCard", data);
}

/*
 解绑  陈斌
 */
 export function unBind(data) {
  return postSettle("/api/client/bindCard/unBind", data);
}

/*
 返回持卡人名字  陈斌
 */
 export function getAcctName(data) {
  return postSettle("/api/client/bindCard/getAcctName", data);
}

/*
 支付验证  陈斌
 */
 export function payVerify(data) {
  return postSettle("/api/client/bindCard/payVerify", data);
}





// WEBPACK FOOTER //
// ./src/api/user.js